<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody:{"type": 0,"token":"b43b64a70f5ea976aa842bec0734bf29"},
        responseCode:{"data":{"authRedirectUrl":"https://devnew.xxx.xin/weixin/autologin/logining.do?onceToken=b43b64a70f5ea976aa842bec0734bf29"},"message":"业务成功","resultCode":0,"status":1},
        infoData: {
          explain: "第三方系统主动请求开放平台，获取相应的h5页面链接",
          t_url: this.commonUrls.test+"getYdtUrl",
          p_url: this.commonUrls.prod+"getYdtUrl",
          precondition: "该接口需要第三方保存有用户的token等信息",
          pattern: "智慧停车开放平台提供接口，第三方接入系统主动请求，获取到地址后，可嵌入第三方的微信公众号中",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'type', info2: '是', info3: 'Integer', info4: '页面类型，0 未登录状态时缴费页面，1 登录状态时缴费页面，2 购买月票时的月票功能页面，3 附近停车场页面，4 车辆管理页面，5 停车费待支付，6 停车优惠券页面，7 停车记录页面，8 停车发票页面，9 预订车位页面，10 用户账单页面' },
              { info1: 'token', info2: '否', info3: 'String', info4: '已登陆的用户标识，与mobile二选一' },
              { info1: 'mobile', info2: '否', info3: 'String', info4: '手机号码，与token二选一' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'authRedirectUrl', info2: '是', info3: 'String', info4: '授权地址' },
            ]
          }
          ]
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getYdtUrl.vue